// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"85481bb3","458":"2ca41661","578":"fca89aa0"}[chunkId] + ".js";
};